import type { ObjectId } from "@bbj-types/utils";
import { Checkbox, Stack, Typography } from "@mui/material";
import { useAuthorizer } from "@styleguide";
import clsx from "clsx";
import type { Dispatch, SetStateAction } from "react";
import { IntegratedTableRow, classes } from "./styles";

export const IntegratedCandidatesHeader = ({
  allSocialApply,
  socialApplySelected,
  setSocialApplySelected,
}: {
  allSocialApply: ObjectId[];
  socialApplySelected: ObjectId[];
  setSocialApplySelected: Dispatch<SetStateAction<ObjectId[]>>;
}) => {
  const isAuthorizedArchive = useAuthorizer(["offers.social.archive"]);
  return (
    <IntegratedTableRow sx={{ scrollbarGutter: "stable" }} isAuthorizedArchive={isAuthorizedArchive}>
      <Stack
        className={clsx(classes.root, classes.header)}
        sx={(theme) => ({ borderBottom: `solid 1px ${theme.palette.gray.main}` })}
      >
        {isAuthorizedArchive && (
          <Checkbox
            size="small"
            color="primary"
            indeterminate={socialApplySelected.length > 0 && allSocialApply.length !== socialApplySelected.length}
            checked={socialApplySelected.length > 0}
            onClick={() => {
              if (socialApplySelected.length > 0) {
                setSocialApplySelected([]);
              } else {
                setSocialApplySelected(allSocialApply);
              }
            }}
          />
        )}
        <Typography className={`${classes.cell} ${classes.candidate}`} variant="subtitle2SemiBold" color="primary">
          Candidat
        </Typography>
        <Typography
          className={`${classes.cell} ${classes.prescriptionDate}`}
          variant="subtitle2SemiBold"
          color="primary"
        >
          Prescription
        </Typography>
        <Typography
          className={`${classes.cell} ${classes.prescriptionDate}`}
          variant="subtitle2SemiBold"
          color="primary"
        >
          Date réponse
        </Typography>
        <Typography
          className={`${classes.cell} ${classes.prescriptionDate}`}
          variant="subtitle2SemiBold"
          color="primary"
        >
          1er accueil
        </Typography>

        <Typography
          className={`${classes.cell} ${classes.prescriptionDate}`}
          variant="subtitle2SemiBold"
          color="primary"
        >
          Bilan prévu
        </Typography>
        <Typography className={`${classes.cell} ${classes.author}`} variant="subtitle2SemiBold" color="primary">
          Auteur
        </Typography>

        <Typography className={`${classes.cell} ${classes.accompaniement}`} variant="subtitle2SemiBold" color="primary">
          Accompagnements
        </Typography>
      </Stack>
    </IntegratedTableRow>
  );
};
